export default {
      id: "icon-tel-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#icon-tel",
      toString: function () {
        return this.url;
      }
    }